const onDistributionKeysPageMatch = async (pathname, regex) => {
  const urlParams = pathname.match(regex)
  const propertyHrId = urlParams[1]

  let propertyId = null
  let isInjecting = false

  // Fetch property data to get propertyId
  const fetchPropertyData = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('auth'))?.token
      if (!token) throw new Error('Auth Token nicht gefunden.')

      const response = await fetch(
        `/services/pmp-accounting/api/v1/properties/${propertyHrId}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      )

      if (!response.ok) {
        throw new Error(`Failed to fetch property data: ${response.statusText}`)
      }

      const propertyData = await response.json()
      return propertyData
    } catch (error) {
      console.error('Error fetching property data:', error)
      throw error
    }
  }

  // Fetch unit-sets data
  const fetchUnitSets = async (propertyId) => {
    try {
      const token = JSON.parse(localStorage.getItem('auth'))?.token
      if (!token) throw new Error('Auth Token nicht gefunden.')

      const response = await fetch(
        `/services/pmp-accounting/api/v1/unit-sets?propertyId=${propertyId}`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      )

      if (!response.ok) {
        throw new Error(`Failed to fetch unit-sets: ${response.statusText}`)
      }

      const unitSetsData = await response.json()
      return Array.isArray(unitSetsData) ? unitSetsData : []
    } catch (error) {
      console.error('Error fetching unit-sets:', error)
      return []
    }
  }

  // Create and inject select element
  const injectUnitSetsSelect = async () => {
    // Check if select already exists in the entire document to avoid duplicates
    if (document.querySelector('.weg-unit-sets-select')) {
      return true
    }

    // Prevent concurrent executions
    if (isInjecting) {
      return false
    }

    const row = document.querySelector('.DistributionKeyDetailsHeader > .ant-row')
    if (!row) {
      return false
    }
    
    // Get all ant-col-8 elements and select the third one
    const cols = row.querySelectorAll('.ant-col.ant-col-8')
    const targetElement = cols[2] // Third element (0-indexed)
    if (!targetElement) {
      return false
    }

    // Double-check before starting injection
    if (targetElement.querySelector('.weg-unit-sets-select') || document.querySelector('.weg-unit-sets-select')) {
      return true
    }

    isInjecting = true

    try {
      // Fetch property data to get propertyId
      if (!propertyId) {
        const propertyData = await fetchPropertyData()
        propertyId = propertyData.id || propertyData.propertyId
        if (!propertyId) {
          throw new Error('Property ID not found in property data')
        }
      }

      // Fetch unit-sets
      const unitSets = await fetchUnitSets(propertyId)

      // Start in read-only mode (will be updated by button clicks)
      let isReadOnly = true
      let selectedUnitSetId = null // 'all' for "Alle Einheiten", or unit set ID
      let isUpdatingCheckboxes = false // Flag to prevent recursive updates

      // Create select container
      const selectContainer = document.createElement('div')
      selectContainer.className = 'weg-unit-sets-select'
      selectContainer.style.cssText = `
        width: 100%;
      `

      // Add heading
      const heading = document.createElement('div')
      heading.textContent = 'Einheitenset'
      heading.style.cssText = `
        margin-bottom: 8px;
        font-size: 16px;
        margin-top: 4px;
        margin-bottom: 10px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
      `
      selectContainer.appendChild(heading)

      // Create select element
      const selectWrapper = document.createElement('div')
      selectWrapper.className = `ant-select ant-select-single impowerx-select${isReadOnly ? ' ant-select-disabled' : ''}`
      selectWrapper.style.cssText = `
        width: 100%;
      `

      const selectSelector = document.createElement('div')
      selectSelector.className = 'ant-select-selector'
      selectSelector.style.cssText = `
        position: relative;
        background-color: ${isReadOnly ? '#eee' : '#fff'};
        border-radius: .6rem;
        border: ${isReadOnly ? '.2rem solid transparent;' : '.2rem solid #eee;'};
        transition: all 0.3s;
        cursor: ${isReadOnly ? 'not-allowed' : 'pointer'};
        min-height: 40px;
        opacity: 1;
      `

      const selectSelection = document.createElement('div')
      selectSelection.className = 'ant-select-selection-search'
      selectSelection.style.cssText = `
        position: absolute;
        top: 0;
        right: 11px;
        bottom: 0;
        left: 11px;
      `

      const selectSelectionInput = document.createElement('input')
      selectSelectionInput.className = 'ant-select-selection-search-input'
      selectSelectionInput.type = 'text'
      selectSelectionInput.autocomplete = 'off'
      selectSelectionInput.role = 'combobox'
      selectSelectionInput.readOnly = true
      selectSelectionInput.style.cssText = `
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        cursor: pointer;
      `

      const selectSelectionItem = document.createElement('span')
      selectSelectionItem.className = 'ant-select-selection-item'
      selectSelectionItem.textContent = 'Einheitenset auswählen...'
      selectSelectionItem.style.cssText = `
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 11px;
        right: 11px;
        font-weight: 500;
        font-size: 16px;
        color: ${isReadOnly ? '#757575' : '#000'};
      `

      const selectArrow = document.createElement('span')
      selectArrow.className = 'ant-select-arrow'
      selectArrow.innerHTML = `
        <span role="img" class="anticon">
          <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L5 5L10 0H0Z" fill="currentColor"></path>
          </svg>
        </span>
      `
      selectArrow.style.cssText = `
        position: absolute;
        top: 50%;
        right: 11px;
        pointer-events: none;
        color: rgba(0, 0, 0, 0.85);
      `

      selectSelection.appendChild(selectSelectionInput)
      selectSelector.appendChild(selectSelection)
      selectSelector.appendChild(selectSelectionItem)
      selectSelector.appendChild(selectArrow)
      selectWrapper.appendChild(selectSelector)

      // Create dropdown
      const dropdownWrapper = document.createElement('div')
      dropdownWrapper.className = 'dropdown-wrapper'
      dropdownWrapper.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 2000;
      `

      const dropdown = document.createElement('div')
      dropdown.className = 'ant-select-dropdown ant-select-dropdown-placement-bottomLeft ant-select-dropdown-hidden impowerx-select-dropdown'
      dropdown.style.cssText = `
        width: 100%;
        left: 0;
        top: 35px;
        background: #fff;
        border: 1px solid #d9d9d9;
        border-radius: .6rem;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        max-height: 256px;
        overflow-y: auto;
      `

      const dropdownContent = document.createElement('div')
      dropdownContent.className = 'rc-virtual-list'
      dropdownContent.style.cssText = `
        position: relative;
      `

      const dropdownHolder = document.createElement('div')
      dropdownHolder.className = 'rc-virtual-list-holder'
      dropdownHolder.style.cssText = `
        max-height: 256px;
        overflow-y: auto;
      `

      const dropdownInner = document.createElement('div')
      dropdownInner.className = 'rc-virtual-list-holder-inner'
      dropdownInner.style.cssText = `
        display: flex;
        flex-direction: column;
      `

      // Add "Alle Einheiten" option first
      const alleEinheitenOption = document.createElement('div')
      alleEinheitenOption.className = 'ant-select-item ant-select-item-option'
      alleEinheitenOption.dataset.value = 'all'
      alleEinheitenOption.textContent = 'Alle Einheiten'
      alleEinheitenOption.style.cssText = `
        padding: 8px 12px;
        cursor: ${isReadOnly ? 'not-allowed' : 'pointer'};
        transition: background-color 0.3s;
      `
      if (!isReadOnly) {
        alleEinheitenOption.onmouseenter = () => {
          alleEinheitenOption.style.backgroundColor = '#eee'
        }
        alleEinheitenOption.onmouseleave = () => {
          alleEinheitenOption.style.backgroundColor = 'transparent'
        }
        alleEinheitenOption.onclick = (e) => {
          e.stopPropagation()
          console.log('[Unit Sets] "Alle Einheiten" option clicked')
          selectedUnitSetId = 'all'
          selectSelectionItem.textContent = 'Alle Einheiten'
          selectSelectionItem.style.color = '#000'
          dropdown.classList.add('ant-select-dropdown-hidden')
          updateTableCheckboxes('all')
        }
      }
      dropdownInner.appendChild(alleEinheitenOption)

      // Add options
      if (unitSets.length === 0) {
        const emptyOption = document.createElement('div')
        emptyOption.className = 'ant-select-item ant-select-item-option ant-select-item-option-disabled'
        emptyOption.textContent = 'Keine Einheitensets verfügbar'
        emptyOption.style.cssText = `
          padding: 8px 12px;
          color: rgba(0, 0, 0, 0.25);
        `
        dropdownInner.appendChild(emptyOption)
      } else {
        unitSets.forEach((unitSet) => {
          const option = document.createElement('div')
          option.className = 'ant-select-item ant-select-item-option'
          option.dataset.value = unitSet.id
          option.textContent = unitSet.name || 'Unbenannt'
          option.style.cssText = `
            padding: 8px 12px;
            cursor: ${isReadOnly ? 'not-allowed' : 'pointer'};
            transition: background-color 0.3s;
          `
          if (!isReadOnly) {
            option.onmouseenter = () => {
              option.style.backgroundColor = '#eee'
            }
            option.onmouseleave = () => {
              option.style.backgroundColor = 'transparent'
            }
            option.onclick = (e) => {
              e.stopPropagation()
              console.log('[Unit Sets] Unit set option clicked:', unitSet.id, unitSet.name)
              selectedUnitSetId = unitSet.id
              selectSelectionItem.textContent = unitSet.name || 'Unbenannt'
              selectSelectionItem.style.color = '#000'
              dropdown.classList.add('ant-select-dropdown-hidden')
              updateTableCheckboxes(unitSet.id)
            }
          }
          dropdownInner.appendChild(option)
        })
      }

      dropdownHolder.appendChild(dropdownInner)
      dropdownContent.appendChild(dropdownHolder)
      dropdown.appendChild(dropdownContent)
      dropdownWrapper.appendChild(dropdown)
      selectWrapper.appendChild(dropdownWrapper)
      selectContainer.appendChild(selectWrapper)

      // Handle click to show/hide dropdown (only if not disabled)
      if (!isReadOnly) {
        selectWrapper.onclick = (e) => {
          e.stopPropagation()
          const isHidden = dropdown.classList.contains('ant-select-dropdown-hidden')
          // Hide all other dropdowns
          document.querySelectorAll('.impowerx-select-dropdown').forEach(d => {
            d.classList.add('ant-select-dropdown-hidden')
          })
          if (isHidden) {
            dropdown.classList.remove('ant-select-dropdown-hidden')
          } else {
            dropdown.classList.add('ant-select-dropdown-hidden')
          }
        }
      }

      // Hide dropdown when clicking outside
      const handleClickOutside = (e) => {
        if (!selectContainer.contains(e.target)) {
          dropdown.classList.add('ant-select-dropdown-hidden')
        }
      }
      document.addEventListener('click', handleClickOutside)

      // Final check before appending
      if (targetElement.querySelector('.weg-unit-sets-select') || document.querySelector('.weg-unit-sets-select')) {
        isInjecting = false
        return true
      }

      targetElement.appendChild(selectContainer)

      // Function to update checkboxes based on selected unit set
      const updateTableCheckboxes = (unitSetId) => {
        console.log('[Unit Sets] updateTableCheckboxes called with unitSetId:', unitSetId)
        isUpdatingCheckboxes = true
        const distributionKeyDetails = document.querySelector('#distributionKeyDetails')
        if (!distributionKeyDetails) {
          console.log('[Unit Sets] ERROR: #distributionKeyDetails not found')
          return
        }
        console.log('[Unit Sets] Found #distributionKeyDetails:', distributionKeyDetails)
        
        const tbody = distributionKeyDetails.querySelector('.ant-table-tbody')
        if (!tbody) {
          console.log('[Unit Sets] ERROR: .ant-table-tbody not found within #distributionKeyDetails')
          return
        }
        console.log('[Unit Sets] Found tbody:', tbody)

        const rows = tbody.querySelectorAll('tr')
        console.log('[Unit Sets] Found rows:', rows.length)
        let unitNumbersToCheck = new Set()

        if (unitSetId === 'all') {
          console.log('[Unit Sets] Processing "Alle Einheiten" - checking all rows')
          // "Alle Einheiten" - check all rows
          rows.forEach((row, index) => {
            const tds = row.querySelectorAll('td')
            console.log(`[Unit Sets] Row ${index}: found ${tds.length} tds`)
            if (tds.length >= 8) {
              const checkboxWrapper7 = tds[6].querySelector('.ant-checkbox')
              const checkboxWrapper8 = tds[7].querySelector('.ant-checkbox')
              console.log(`[Unit Sets] Row ${index}: checkboxWrapper7=${!!checkboxWrapper7}, checkboxWrapper8=${!!checkboxWrapper8}`)
              
              // Only click if not already checked
              if (checkboxWrapper7 && !checkboxWrapper7.classList.contains('ant-checkbox-checked')) {
                checkboxWrapper7.click()
                console.log(`[Unit Sets] Row ${index}: Clicked checkbox7 to check`)
              } else if (checkboxWrapper7) {
                console.log(`[Unit Sets] Row ${index}: checkbox7 already checked`)
              }
              
              if (checkboxWrapper8 && !checkboxWrapper8.classList.contains('ant-checkbox-checked')) {
                checkboxWrapper8.click()
                console.log(`[Unit Sets] Row ${index}: Clicked checkbox8 to check`)
              } else if (checkboxWrapper8) {
                console.log(`[Unit Sets] Row ${index}: checkbox8 already checked`)
              }
            }
          })
          return
        }

        // Find the selected unit set
        console.log('[Unit Sets] Looking for unit set with id:', unitSetId)
        console.log('[Unit Sets] Available unit sets:', unitSets.map(us => ({ id: us.id, name: us.name })))
        const selectedUnitSet = unitSets.find(us => us.id.toString() === unitSetId.toString())
        if (!selectedUnitSet) {
          console.log('[Unit Sets] ERROR: Unit set not found')
          return
        }
        if (!selectedUnitSet.units) {
          console.log('[Unit Sets] ERROR: Unit set has no units array')
          return
        }
        console.log('[Unit Sets] Found unit set:', selectedUnitSet.name, 'with', selectedUnitSet.units.length, 'units')

        // Collect unit numbers from the selected unit set
        selectedUnitSet.units.forEach(unit => {
          if (unit.unitNrSharingDeclaration) {
            unitNumbersToCheck.add(unit.unitNrSharingDeclaration)
          }
        })
        console.log('[Unit Sets] Unit numbers to check:', Array.from(unitNumbersToCheck))

        // Update checkboxes based on unit numbers
        rows.forEach((row, index) => {
          const tds = row.querySelectorAll('td')
          if (tds.length >= 8) {
            // Get unitNrSharingDeclaration from second td (index 1)
            const unitNr = tds[1].textContent.trim()
            const shouldCheck = unitNumbersToCheck.has(unitNr)
            console.log(`[Unit Sets] Row ${index}: unitNr="${unitNr}", shouldCheck=${shouldCheck}`)

            // Get checkbox wrappers in columns 7 and 8 (indices 6 and 7)
            const checkboxWrapper7 = tds[6].querySelector('.ant-checkbox')
            const checkboxWrapper8 = tds[7].querySelector('.ant-checkbox')
            console.log(`[Unit Sets] Row ${index}: checkboxWrapper7=${!!checkboxWrapper7}, checkboxWrapper8=${!!checkboxWrapper8}`)

            // Check current state using .ant-checkbox-checked class and click if needed
            if (checkboxWrapper7) {
              const isChecked7 = checkboxWrapper7.classList.contains('ant-checkbox-checked')
              if (shouldCheck && !isChecked7) {
                checkboxWrapper7.click()
                console.log(`[Unit Sets] Row ${index}: Clicked checkbox7 to check`)
              } else if (!shouldCheck && isChecked7) {
                checkboxWrapper7.click()
                console.log(`[Unit Sets] Row ${index}: Clicked checkbox7 to uncheck`)
              } else {
                console.log(`[Unit Sets] Row ${index}: checkbox7 already in correct state (checked=${isChecked7})`)
              }
            }
            
            if (checkboxWrapper8) {
              const isChecked8 = checkboxWrapper8.classList.contains('ant-checkbox-checked')
              if (shouldCheck && !isChecked8) {
                checkboxWrapper8.click()
                console.log(`[Unit Sets] Row ${index}: Clicked checkbox8 to check`)
              } else if (!shouldCheck && isChecked8) {
                checkboxWrapper8.click()
                console.log(`[Unit Sets] Row ${index}: Clicked checkbox8 to uncheck`)
              } else {
                console.log(`[Unit Sets] Row ${index}: checkbox8 already in correct state (checked=${isChecked8})`)
              }
            }
          } else {
            console.log(`[Unit Sets] Row ${index}: Skipped (only ${tds.length} tds, need 8)`)
          }
        })
        console.log('[Unit Sets] Finished updating checkboxes')
        // Reset flag after a short delay to allow checkbox state to update
        setTimeout(() => {
          isUpdatingCheckboxes = false
        }, 100)
      }

      // Function to reset unit set selection when checkboxes are manually changed
      const resetUnitSetSelection = () => {
        if (selectedUnitSetId !== null) {
          selectedUnitSetId = null
          selectSelectionItem.textContent = 'Einheitenset auswählen...'
          selectSelectionItem.style.color = '#757575'
        }
      }

      // Function to update disabled state
      const updateDisabledState = (readOnly) => {
        if (readOnly === isReadOnly) {
          return // No change needed
        }
        isReadOnly = readOnly
        
        if (readOnly) {
          selectWrapper.classList.add('ant-select-disabled')
          selectSelector.style.backgroundColor = '#eee'
          selectSelector.style.border = '.2rem solid transparent'
          selectSelector.style.cursor = 'not-allowed'
          selectSelectionItem.style.color = '#757575'
          selectWrapper.onclick = null
          dropdownInner.querySelectorAll('.ant-select-item-option').forEach(opt => {
            opt.style.cursor = 'not-allowed'
            opt.onclick = null
            opt.onmouseenter = null
            opt.onmouseleave = null
          })
        } else {
          selectWrapper.classList.remove('ant-select-disabled')
          selectSelector.style.backgroundColor = '#fff'
          selectSelector.style.border = '.2rem solid #eee'
          selectSelector.style.cursor = 'pointer'
          selectSelectionItem.style.color = '#000'
          selectWrapper.onclick = (e) => {
            e.stopPropagation()
            const isHidden = dropdown.classList.contains('ant-select-dropdown-hidden')
            document.querySelectorAll('.impowerx-select-dropdown').forEach(d => {
              d.classList.add('ant-select-dropdown-hidden')
            })
            if (isHidden) {
              dropdown.classList.remove('ant-select-dropdown-hidden')
            } else {
              dropdown.classList.add('ant-select-dropdown-hidden')
            }
          }
          dropdownInner.querySelectorAll('.ant-select-item-option').forEach(opt => {
            opt.style.cursor = 'pointer'
            const unitSetId = opt.dataset.value
            
            if (unitSetId === 'all') {
              // Handle "Alle Einheiten" option
              opt.onmouseenter = () => {
                opt.style.backgroundColor = '#eee'
              }
              opt.onmouseleave = () => {
                opt.style.backgroundColor = 'transparent'
              }
              opt.onclick = (e) => {
                e.stopPropagation()
                selectedUnitSetId = 'all'
                selectSelectionItem.textContent = 'Alle Einheiten'
                selectSelectionItem.style.color = '#000'
                dropdown.classList.add('ant-select-dropdown-hidden')
                updateTableCheckboxes('all')
              }
            } else {
              // Handle unit set options
              const unitSet = unitSets.find(us => us.id.toString() === unitSetId)
              if (unitSet) {
                opt.onmouseenter = () => {
                  opt.style.backgroundColor = '#eee'
                }
                opt.onmouseleave = () => {
                  opt.style.backgroundColor = 'transparent'
                }
                opt.onclick = (e) => {
                  e.stopPropagation()
                  selectedUnitSetId = unitSet.id
                  selectSelectionItem.textContent = unitSet.name || 'Unbenannt'
                  selectSelectionItem.style.color = '#000'
                  dropdown.classList.add('ant-select-dropdown-hidden')
                  updateTableCheckboxes(unitSet.id)
                }
              }
            }
          })
        }
      }

      // Watch for button clicks to toggle edit/read-only mode
      const handleButtonClick = (e) => {
        if (e.target.closest('.ant-btn-primary')) {
          updateDisabledState(false) // Edit button - enable (edit mode)
        } else if (e.target.closest('.ant-btn-ghost')) {
          updateDisabledState(true) // Save button - disable (read-only mode)
        }
      }
      document.addEventListener('click', handleButtonClick)

      // Watch for manual checkbox changes to update unit set selection
      const handleCheckboxChange = (e) => {
        // Only process if not programmatically updating and checkbox is in the distribution key table
        if (isUpdatingCheckboxes) {
          return
        }
        
        const checkbox = e.target.closest('.ant-checkbox')
        if (!checkbox) {
          return
        }
        
        const distributionKeyDetails = document.querySelector('#distributionKeyDetails')
        if (!distributionKeyDetails || !distributionKeyDetails.contains(checkbox)) {
          return
        }
        
        // Debounce the update to avoid multiple calls
        clearTimeout(handleCheckboxChange.timeoutId)
        handleCheckboxChange.timeoutId = setTimeout(() => {
          resetUnitSetSelection()
        }, 100)
      }
      document.addEventListener('click', handleCheckboxChange)

      // Initial state - check if we're already in edit mode
      // Check other selects on the page (excluding our own dropdown) to determine the current mode
      const otherDisabledSelects = Array.from(document.querySelectorAll('.ant-select.ant-select-disabled'))
        .filter(select => !select.closest('.weg-unit-sets-select'))
      const hasDisabledSelects = otherDisabledSelects.length > 0
      updateDisabledState(hasDisabledSelects)

      isInjecting = false
      return true
    } catch (error) {
      console.error('Error injecting unit-sets select:', error)
      isInjecting = false
      return false
    }
  }

  // Wait for the target element to be present
  let attempts = 0
  const maxAttempts = 60 // 30 seconds max (60 * 500ms)
  let observer = null
  
  const waitForElement = setInterval(async () => {
    attempts++
    const injected = await injectUnitSetsSelect()
    if (injected) {
      clearInterval(waitForElement)
      if (observer) {
        observer.disconnect()
      }
    }
    if (attempts >= maxAttempts) {
      clearInterval(waitForElement)
      if (observer) {
        observer.disconnect()
      }
    }
  }, 500)

  // Also observe for when the element appears
  observer = new MutationObserver(async () => {
    // Check if already injected before trying again
    if (!document.querySelector('.weg-unit-sets-select')) {
      const injected = await injectUnitSetsSelect()
      if (injected && observer) {
        observer.disconnect()
      }
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

